import Vue from "vue";
import qs from "qs";
import axios from "axios";
import store from "@/vuex";
import router from '@/router';
import { wyy } from "@/env";
import { message } from 'ant-design-vue';

const headers  = {
    'Content-Type': "application/x-www-form-urlencoded;charset=UTF-8",
}

const instance = axios.create({
    baseURL: wyy.url + 'wyy/',
    timeout: 1000,
    headers: headers,
    withCredentials: true
});

instance.interceptors.request.use(function (config) {
    delete config.headers.Authorization;
    return config;
}, function (error) {
    // 对请求错误做些什么
    return Promise.reject(error);
});


instance.interceptors.response.use(
    response => {
        const code = response.data.code || 0;
        switch (code) {
            default:
                return Promise.reject(response);
        }
    },
    error => {
        // console.log('api err', error);
        // console.log('api err', error.response);
        if (error.response.status) {
            switch (error.response.status) {
                case 404:
                    break;
                default:
                    break;
            }
        }
        return Promise.reject(error.response);
    }
);

export function $get(url, data) {
    let _self = this;
    return new Promise((resolve, reject) => {
        instance
            .get(url, { params: {
                ...data,
                cookie: store.state.wyy.cookie
            } })
            .then(res => {
                resolve(res.data);
            })
            .catch(function (error) {
                resolve(error.data);
            });
    });
}

export function $post(url, data) {
    let _self = this;
    return new Promise((resolve, reject) => {
        //qs.stringify()将对象序列化成URL的形式，以&进行拼接
        instance
            .post(url, qs.stringify(data))
            .then(res => {
                resolve(res.data);
            })
            .catch(function (error) {
                resolve(error.data);
            });
    });
}



// WEBPACK FOOTER //
// ./src/api/config/wyy.js